import "./ItemsNeeded.css";
import React, { useEffect, useState } from "react";
import config from "../../config";
import fetchWithAuth from '../../services/fetchWithAuth';  

const BASE_API = config.API_BASE_URL;

// Sample data type
interface ItemNeeded {
  sku: string;
  name: string;
  qtyNeeded: number;
}

// Component Props
interface ItemsNeededProps {
  fundraiser_id: number;
}

const fetchItemsNeeded = async (
  fundraiserId: number
): Promise<ItemNeeded[]> => {
  // Construct the base URL
  let url = BASE_API + "orders/needed-skus";

  // Append the 'fundraiser' query parameter only if fundraiserId is not 0
  if (fundraiserId !== 0) {
    url += `?fundraiser=${fundraiserId}`;
  }

  const response = await fetchWithAuth(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Error fetching items: ${response.statusText}`);
  }

  const data: ItemNeeded[] = await response.json();
  return data;
};
const ItemsNeeded: React.FC<ItemsNeededProps> = ({ fundraiser_id }) => {
  const [itemsNeeded, setItemsNeeded] = useState<ItemNeeded[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await fetchItemsNeeded(fundraiser_id);
        setItemsNeeded(data);
      } catch (err) {
        setError("Failed to fetch items needed.");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [fundraiser_id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div>
      <h2>Items Needed for Current Processing Orders</h2>
      <table className="warehouse-order-table">
        <thead>
          <tr>
            <th>SKU</th>
            <th>Item Name</th>
            <th>Qty Needed</th>
          </tr>
        </thead>
        <tbody>
          {itemsNeeded.length > 0 ? (
            itemsNeeded.map((item: any) => (
              <tr key={item.sku}>
                <td>{item.sku}</td>
                <td>{item.product_name}</td>
                <td>{item.quantity}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={3} className="no-items">
                No items needed.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ItemsNeeded;
